import { useEffect, useState } from "react";
import { HandCoins } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

// Interruptor por entidad: el ejecutivo de crédito desembolsa los créditos que originó.
// Guardado propio (colección aparte); el backend solo deja cambiarlo a admin_entidad.
export default function DesembolsoOriginadorSwitch() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/desembolso-originador/config")
      .then((r) => setCfg(r.data))
      .catch(() => setCfg({ habilitado: false, puede_editar: false }));
  }, []);

  const cambiar = async (v) => {
    setSaving(true);
    try {
      const { data } = await api.put("/desembolso-originador/config", { habilitado: v });
      setCfg(data);
      toast.success(v ? "Los ejecutivos ya pueden desembolsar sus créditos." : "Opción desactivada: solo Mesa de Control y Administrador desembolsan.");
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  if (!cfg) return null;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5" data-testid="card-desembolso-originador">
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <h4 className="flex items-center gap-2 font-heading text-sm font-semibold text-slate-700">
            <HandCoins className="h-4 w-4 text-forest-600" /> Permitir que los ejecutivos de crédito desembolsen sus créditos
          </h4>
          <p className="text-xs text-slate-500">
            Encendido: el ejecutivo ve en Mesa de Control solo los créditos de clientes que él originó y que el Comité aprobó o condicionó.
            Se mantienen todos los candados del desembolso (PLD, autorización del Oficial de Cumplimiento, coincidencias, fechas).
          </p>
          {cfg.actualizado_at && (
            <p className="text-[11px] text-slate-400" data-testid="desembolso-originador-ultimo-cambio">
              Último cambio: {cfg.actualizado_por} · {String(cfg.actualizado_at).slice(0, 16).replace("T", " ")}
            </p>
          )}
          {!cfg.puede_editar && (
            <p className="text-[11px] text-amber-700" data-testid="desembolso-originador-solo-admin">
              Solo el Administrador de la entidad puede cambiar esta opción.
            </p>
          )}
        </div>
        <Switch data-testid="switch-desembolso-originador" checked={!!cfg.habilitado}
          onCheckedChange={cambiar} disabled={!cfg.puede_editar || saving} />
      </div>
    </div>
  );
}
